import { ChartData } from 'chart.js';
import { useAppSelector } from 'services/configuration/store/hooks';

import { SelectOption, SelectOptionsValues } from '../../types';
import { consumtpionVsProductionData } from './options/consumtpionVsProductionData';
import { energyDemandVsProduction } from './options/energyDemandVsProduction';
import { energyStorage } from './options/energyStorage';
import { heatStorage } from './options/heatStorage';
import { getObliczeniaReducer } from 'services/slices/obliczeniaSlice/selectors';
import { magazynCieplaPrzemyslowego } from './options/magazynCieplaPrzemyslowego';
import { LegendOption, LegendOptionWithLabel } from 'components/Legend/Legend';
import { useTranslation } from 'react-i18next';
import { DATASET_LABELS } from '../../consts';
import { keys } from 'i18n/keys';
type UseDataset = {
  selectedOption: SelectOption;
  filterByPeriod: (_: any, i: number) => boolean;
};
export const useDataset = ({
  selectedOption,
  filterByPeriod,
}: UseDataset): {
  dataset: ChartData<'line', number[], string>['datasets'];
  legendOptions?: LegendOption[];
  optionsWithLabel?: LegendOptionWithLabel[];
  maxNumb: number;
} => {
  const { t } = useTranslation();
  const {
    produkcjaEnergiiElektrycznej: { inputs: productionInputs, calculations: productionCalculations },
    obliczenia: { inputs: obliczeniaInputs, calculations: obliczeniaCalc, cieplo },
  } = useAppSelector(getObliczeniaReducer);
  const heatInputs = cieplo.inputs;
  const datasets = {
    // [SelectOptionsValues.All]: all,
    [SelectOptionsValues.EnergyDemandVsProduction]: consumtpionVsProductionData({
      filterByPeriod,
      heatInputs,
      productionCalculations,
      obliczeniaCalc,
      obliczeniaInputs,
    }),
    [SelectOptionsValues.EnergyProductionVsDemand]: energyDemandVsProduction({
      productionInputs,
      productionCalculations,
      obliczeniaInputs,
      obliczeniaCalc,
      filterByPeriod,
    }),
    [SelectOptionsValues.EnergyStorage]: energyStorage({ filterByPeriod, obliczeniaCalc, obliczeniaInputs }),
    [SelectOptionsValues.HeatStorage]: heatStorage({ filterByPeriod, obliczeniaCalc, obliczeniaInputs }),
    [SelectOptionsValues.MagazynCieploPrzemyslowe]: magazynCieplaPrzemyslowego({
      filterByPeriod,
      obliczeniaCalc,
      obliczeniaInputs,
    }),
  };
  const { dataset, maxNumb } = datasets[selectedOption.value]();
  const legendOptions: LegendOption[] = dataset.map(el => ({
    color: el.backgroundColor as string,
    name: t(el.label!),
    borderColor: el.borderColor as string,
  }));

  const optionsWithLabel: LegendOptionWithLabel[] | undefined =
    selectedOption.value === SelectOptionsValues.EnergyProductionVsDemand
      ? [
          {
            label: t(keys.ENERGY_SUPPLIES),
            options: dataset
              .filter(el => !el.borderWidth)
              .map(el => ({
                color: el.backgroundColor as string,
                name: t(el.label!),
                borderColor: el.borderColor as string,
              })),
          },
          {
            label: t(keys.HYDROGEN_DATA_ZAPOTRZ),
            options: dataset
              .filter(el => el.borderWidth)
              .map(el => ({
                color: el.borderColor as string,
                //@ts-ignore
                name: t((el.descLabel as string | undefined) ?? el.label!),
                borderColor: el.borderColor as string,
              })),
          },
        ]
      : undefined;

  return {
    dataset,
    legendOptions,
    optionsWithLabel,
    maxNumb,
  };
};
